import { render, staticRenderFns } from "./MasiveCharge.vue?vue&type=template&id=46dc6cb2&scoped=true"
import script from "./MasiveCharge.vue?vue&type=script&lang=js"
export * from "./MasiveCharge.vue?vue&type=script&lang=js"
import style0 from "./MasiveCharge.vue?vue&type=style&index=0&id=46dc6cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc6cb2",
  null
  
)

export default component.exports